import { Button, Result } from 'antd';
import { Link } from 'react-router';

/** The 404 route (docs/07-implementation-roadmap.md F0.7). */
export function NotFound() {
  return (
    <Result
      status="404"
      title="Halaman tidak ditemukan"
      subTitle="Alamat yang Anda buka tidak ada. Periksa kembali tautannya, atau kembali ke beranda."
      extra={
        <Link to="/">
          <Button type="primary">Kembali ke beranda</Button>
        </Link>
      }
    />
  );
}
